export default {
    init() {
        this.loaded = false;
        this.bindEvents();
        this.warning = $('#grnhse-warning');
        if(this.warning.length < 1) return;

        setTimeout(() => {
            if (this.loaded) return;
            this.warning.addClass('visible');
        }, 4000);
    },
    bindEvents() {
        window.addEventListener('message', message => {
            if (message.origin !== 'https://boards.eu.greenhouse.io') return;
            this.loaded = true;
            this.warning.removeClass('visible');
        });
    },
};